import {
    FETCH_SYSTEM_CONSTANTS_REQUEST,
    FETCH_SYSTEM_CONSTANTS_SUCCESS,
    FETCH_SYSTEM_CONSTANTS_FAILURE
} from '../actions/systemConstantsActions.js';

const initialState = {
    constants: null,
    loading: false,
    error: null
};

export const systemConstantsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SYSTEM_CONSTANTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        
        case FETCH_SYSTEM_CONSTANTS_SUCCESS:
            return {
                ...state,
                loading: false,
                constants: action.payload,
                error: null
            };
        
        case FETCH_SYSTEM_CONSTANTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        default:
            return state;
    }
};
